import { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { Photo } from "./Photo";

const spring = { stiffness: 120, damping: 18, mass: 0.4 };

export const GalleryItem = ({ item, index, onOpen }) => {
  const ref = useRef(null);
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const x = useSpring(mx, spring);
  const y = useSpring(my, spring);

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    mx.set(((e.clientX - r.left) / r.width - 0.5) * -14);
    my.set(((e.clientY - r.top) / r.height - 0.5) * -14);
  };
  const onLeave = () => {
    mx.set(0);
    my.set(0);
  };

  return (
    <button
      ref={ref}
      type="button"
      data-testid={`gallery-item-${index}`}
      onClick={onOpen}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={`group block w-full break-inside-avoid overflow-hidden text-left ${item.src ? "" : item.aspect}`}
      aria-label={`Open image: ${item.label}`}
    >
      <motion.div style={{ x, y }} className="h-full w-full transition-transform duration-700 ease-out group-hover:scale-[1.08]">
        <Photo src={item.src} alt={item.alt} label={item.label} tone={item.tone} />
      </motion.div>
    </button>
  );
};
